class SubscriptionsPage {
    constructor() {
        this.customerEmail = window.settings.user.email;
    }

    async fetchSubscriptions() {
        if (!this.customerEmail) {
            console.error("Customer email is not provided.");
            return;
        }

        try {
            const response = await new Promise((resolve) =>
                maestra("sync", {
                    operation: "GetBackInStockList",
                    data: {
                        email: this.customerEmail,
                    },
                    onSuccess: (data) => resolve(data),
                })
            );
            console.log(response)
            return response;
        } catch (error) {
            console.error("Error fetching subscriptions:", error);
        }
    }

    async displaySubscriptions() {
        const subscriptionsData = await this.fetchSubscriptions();
        const productsContainer = document.createElement("div");
        productsContainer.classList.add("subscriptions-page__products-container");

        const variantIds = subscriptionsData.productList.map(product => product.product.ids.storeez12Shopify)

        const productDetailsListPromises = variantIds.map((variantId) => this.getProductDetails(variantId));
        const productDetailsList = await Promise.all(productDetailsListPromises);

        for (const productDetails of productDetailsList) {
            try {
                const productCard = await this.renderProductCard(productDetails);
                productsContainer.appendChild(productCard);
            } catch (error) {
                console.error("Failed to render product card:", error);
            }
        }

        // Process and display the fetched subscriptions data on the page
    }

    async renderProductCard(productDetails) {
        const productAvailable = productDetails.variant.inventory_quantity > 0;

        const response = await fetch("/snippets/subscription-product-card", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/html",
            },
            body: JSON.stringify({
                product_image: productDetails.image.src,
                product_title: productDetails.title,
                product_price: productDetails.price,
                product_size: productDetails.variant.title,
                product_available: productAvailable,
            }),
        });

        if (response.ok) {
            const html = await response.text();
            const wrapper = document.createElement("div");
            wrapper.innerHTML = html.trim();
            return wrapper.firstChild;
        } else {
            throw new Error("Failed to render product card");
        }
    }

    async getProductDetails(variantId) {
        const response = await fetch(`/variants/${variantId}.json`);
        if (response.ok) {
            // const result = await response.json();
            // console.log(result)
            const { product_variant } = await response.json();
            // console.log(response.json())

            const productGid = `gid://shopify/Product/${product_variant.product_id}`;

            const response2 = await fetch("https://12storeez-eng.myshopify.com/api/2021-07/graphql.json", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": "8b04d4edf1181f216ac02f11a9f0207a",
                },
                body: JSON.stringify({
                    query: `
                      query {
                        product(id: "${productGid}") {
                          id
                          title
                          description
                          images(first: 1) {
                            edges {
                              node {
                                originalSrc
                              }
                            }
                          }
                          variants(first: 1) {
                            edges {
                              node {
                                id
                                title
                                price
                                availableForSale
                              }
                            }
                          }
                        }
                      }
                    `,
                }),
            });

            const data = await response2.json();
            console.log(data)
            const product = data.data.product;
            // products[variantId.product_id] = product;

            // const productResponse = await fetch(`/products/${product_variant.product_id}.json`);
            // if (productResponse.ok) {
            //     const { product } = await productResponse.json();
            //     const image = product.images.find((img) => img.id === product_variant.image_id) || product.images[0];
            //     return {
            //         title: product.title,
            //         price: product_variant.price,
            //         variant: product_variant,
            //         image,
            //     };
            // } else {
            //     throw new Error(`Failed to fetch product details for product ID ${product_variant.product_id}`);
            // }
        } else {
            throw new Error(`Failed to fetch variant details for variant ID ${variantId}`);
        }
    }
}